import React, { useState } from "react";
import "./LanguageFilter.css";
import { Form } from "react-bootstrap";
import CheckBox from "../../../../Simplify360Chat/InitialForm/CheckBox";

export default function LanguageFilter(props) {
  const [refresh, setRefresh] = useState(false);
  //constants/variables
  const { selectedLanguages, allLanguages, onLangChange } = props;
  const tempSelectdLanguages = selectedLanguages;

  //states
  const localSelectedLangsAndGenre = JSON.parse(
    localStorage.getItem("selectedLanguagesAndGenresTemp")
  );

  console.log(localSelectedLangsAndGenre, "localSelectedLangs");
  //useEffects

  //functions
  const handleLanguageCheck = (e) => {
    // props.scrollOnAction();
    const { name, value, checked } = e.target;
    const changedLang = { name, value, checked };
    onLangChange(changedLang);
    setRefresh(!refresh);
  };

  return (
    <div
      className="row m-0"
      style={{
        overflowY: allLanguages.length > 10 ? "scroll" : "hidden",
        height: allLanguages.length > 12 ? "25rem" : "200px",
      }}
    >
      <div className="filterContainer">
        {allLanguages.map((oneLang) => (
          <div className="checkBox-container" key={oneLang}>
            <input
              name="language"
              // disabled={!localSelectedLangsAndGenre?.selectedLanguages?.filter(e => e === oneLang).length > 0 }
              value={oneLang}
              checked={
                selectedLanguages.filter((e) => e === oneLang).length > 0
              }
              className="form-check-label"
              type="checkbox"
              onChange={(e) => {
                handleLanguageCheck(e);
              }}
            />
            <p>{oneLang}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
